import * as React from 'react';

import { useMessageContext } from '../../../../utils/messageContext';
import { IOfferForClient1 } from '../../../../repositories/chats/entities/for_client/OfferForClient1';
import { OfferMessage } from '../../../../components/OfferMessage';
import { ExpertButtonContainer } from '../../../ChatMessageContainer/containers/OfferMessageContainer/containers/ExpertButtonContainer';
import { IOfferMessage } from '../../../ChatMessageContainer/containers/OfferMessageContainer/types';
import { useOfferMessageActions } from '../../../ChatMessageContainer/containers/OfferMessageContainer/hooks/useOfferMessageActions';
import { ERequestApiStatus } from '../../../../types/appState';

interface IOfferGalleryItemProps {
  offer: IOfferForClient1;
}

export const OfferGalleryItem: React.FC<IOfferGalleryItemProps> = ({ offer: offerFromProps }) => {
  const {
    messageRef,
    message: { isOutcoming, status },
  } = useMessageContext();
  const offer = offerFromProps as IOfferMessage;
  const { formattedText, shareUrl, handleReload, onClick } = useOfferMessageActions(offer);

  return (
    <OfferMessage
      isChatbotChat={true}
      isOutcoming={isOutcoming}
      withReload={status === ERequestApiStatus.Failed}
      formattedAddress={offer.formattedAddress}
      formattedInfo={offer.formattedInfo}
      formattedPrice={offer.formattedPrice}
      formattedOldPrice={offer.formattedOldPrice}
      formattedText={formattedText}
      shareUrl={shareUrl}
      photoUrl={offer.photoUrls}
      messageRef={messageRef}
      onReload={handleReload}
      onClick={onClick}
      chatbotButtons={<ExpertButtonContainer offer={offer} />}
    />
  );
};
